if (!customElements.get('blackland-ask-intro')) {
  customElements.define('blackland-ask-intro', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.suggestedInput = null;
      this.lastSuggestedDraft = null;
      const { signal } = this.controller;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-ask-open]');
        if (!button || !this.contains(button)) return;
        const status = this.querySelector('[data-ask-status]');
        status.textContent = '';
        if (!this.openWithSuggestedDraft(button.dataset.askQuestion)) {
          this.refresh();
          status.textContent = 'Please use the Ask Blackland launcher, or explore recipes and flavors.';
        }
      }, { signal });
      this.refresh();
      document.addEventListener('DOMContentLoaded', () => this.refresh(), { once: true, signal });
      document.addEventListener('load', event => {
        if (event.target instanceof HTMLScriptElement) this.refresh();
      }, { capture: true, signal });
      window.addEventListener('load', () => this.refresh(), { once: true, signal });
    }

    assistant() {
      const app = window.ChefBlacklandApp;
      const input = app?.elements?.input;
      return typeof app?.UI?.open === 'function'
        && app.elements?.root?.isConnected
        && app.elements.root.dataset.chefBlacklandInitialized === 'true'
        && app.elements.panel?.isConnected && input?.isConnected
        && ((input instanceof HTMLInputElement && input.type === 'text') || input instanceof HTMLTextAreaElement)
        && !input.disabled && !input.readOnly
        ? app : null;
    }

    openWithSuggestedDraft(question) {
      const app = this.assistant();
      if (!app || typeof question !== 'string' || !question.trim()) return false;
      const input = app.elements.input;
      try {
        if (this.suggestedInput !== input) {
          this.suggestedInput = input;
          this.lastSuggestedDraft = null;
          input.addEventListener('input', () => {
            if (this.suggestedInput === input) this.lastSuggestedDraft = null;
          }, { signal: this.controller.signal });
        }
        if (!input.value.trim() || input.value === this.lastSuggestedDraft) {
          app.UI.resetComposerMode?.();
          const prototype = input instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
          Object.getOwnPropertyDescriptor(prototype, 'value').set.call(input, question);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          this.lastSuggestedDraft = question;
        }
        app.UI.open();
        input.focus({ preventScroll: true });
        return true;
      } catch {
        return false;
      }
    }

    refresh() {
      const ready = Boolean(this.assistant());
      this.querySelectorAll('[data-ask-open]').forEach(button => { button.hidden = !ready; });
      this.querySelectorAll('[data-ask-example]').forEach(example => { example.hidden = ready; });
      this.querySelector('[data-ask-help]').hidden = ready;
    }

    disconnectedCallback() { this.controller?.abort(); }
  });
}
